import { FC } from 'react';
import { WbCard, WbCardContent } from '@agilelab/plugin-wb-platform';
import { EntityListProvider } from '@mainstage/plugin-catalog-react';
import { useTheme } from '@material-ui/core';
import { ComponentsTable } from './ComponentsTable/ComponentsTable';
import { LatestProvisioning } from './LatestProvisioningAccordion/LatestProvisioning';
import { ProvisioningCardActions } from './ProvisioningCardActions';
import { QuickLinks } from './QuickLinks';
import { usePermission } from '@mainstage/plugin-permission-react';
import { builderDpDeployPermission } from '@agilelab/plugin-wb-rbac-common';
import { stringifyEntityRef } from '@mainstage/catalog-model';
import { useReleaseDetailPageContext } from '../context/useReleaseDetailPageContext';

export const ProvisioningCard: FC = () => {
  const theme = useTheme();
  const { environment, entity } = useReleaseDetailPageContext();
  const { allowed: canProvision } = usePermission({
    permission: builderDpDeployPermission(environment.name),
    resourceRef: stringifyEntityRef({
      kind: entity?.kind ?? 'system',
      namespace: 'default',
      name: entity?.metadata.name ?? '',
    }),
  });
  return (
    <EntityListProvider>
      <WbCard
        cardStyle={{ display: 'block' }}
        title="Provisioning"
        actions={<ProvisioningCardActions canProvision={canProvision} />}
      >
        <WbCardContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
          }}
        >
          <LatestProvisioning canProvision={canProvision} />
          <QuickLinks canProvision={canProvision} />
          <ComponentsTable />
        </WbCardContent>
      </WbCard>
    </EntityListProvider>
  );
};
